import React from 'react';
import { StyledDropdownItem, StyledDropdownItemIcon } from './styledCustomerDropdown';

interface IDropdownItemProps {
  name: string;
  icon?: React.FunctionComponent<React.PropsWithChildren<unknown>>;
  dataAnalytics?: string;
  /**
   * component props will be passed through
   */
  [key: string]: unknown;
}

const DropdownItem = (props: IDropdownItemProps): JSX.Element => {
  const { name, icon, dataAnalytics, ...otherProps } = props;

  return (
    <StyledDropdownItem data-test-id="CustomerDropdown-item" data-analytics={dataAnalytics} {...otherProps}>
      {icon && <StyledDropdownItemIcon as={icon} data-test-id="CustomerDropdown-itemIcon" />}
      {name}
    </StyledDropdownItem>
  );
};

export default DropdownItem;
